export enum TaxComputationType {
    ON_GROUPS = 'on_groups',
    FIXED = 'fixed',
    PERCENT = 'percent',
    ON_PAYMENT = 'on_payment',
    DIVISION = 'division'
}
